import React, { useState, useEffect } from 'react';
import { getHealth } from 'api';

const STATUS_META = {
  healthy: { label: 'Healthy', className: 'gh-label-completed', icon: 'bi-check-circle-fill' },
  unhealthy: { label: 'Unhealthy', className: 'gh-label-failed', icon: 'bi-exclamation-triangle-fill' },
  error: { label: 'Error', className: 'gh-label-failed', icon: 'bi-x-circle-fill' },
};

const HealthCheck = () => {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHealth = async () => {
      try {
        setLoading(true);
        setHealth(await getHealth());
      } catch (error) {
        setHealth({ status: 'error', error: 'Health check failed' });
      } finally {
        setLoading(false);
      }
    };
    fetchHealth();
  }, []);

  const meta = health ? (STATUS_META[health.status] || STATUS_META.error) : null;

  return (
    <div className="gh-box">
      <div className="gh-box-header">
        <i className="bi bi-heart-pulse me-2" aria-hidden="true"></i>
        Backend health check
      </div>
      <div className="gh-box-body">
        {loading ? (
          <div className="d-flex align-items-center gap-2 text-muted-gh">
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </div>
        ) : health ? (
          <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted-gh">Status:</span>
              <span className={`gh-label ${meta.className}`}>
                <i className={`bi ${meta.icon}`} aria-hidden="true"></i>
                {meta.label}
              </span>
            </div>
            {health.service && (
              <div>
                <span className="text-muted-gh">Service: </span>
                {health.service}
              </div>
            )}
            {health.version && (
              <div>
                <span className="text-muted-gh">Version: </span>
                {health.version}
              </div>
            )}
            {health.error && <div className="text-danger">{health.error}</div>}
          </div>
        ) : (
          <span className="text-muted-gh">No health check information</span>
        )}
      </div>
    </div>
  );
};

export default HealthCheck;
